const HTTP_PROTOCOLS = ['http:', 'https:'];

const extractIframeSource = (value: string): string | undefined => {
  if (!value.toLowerCase().includes('<iframe')) {
    return undefined;
  }

  const document = new DOMParser().parseFromString(value, 'text/html');
  return document.querySelector('iframe')?.getAttribute('src') || undefined;
};

const normalizeEmbedUrl = (value: string): string | undefined => {
  const candidate = extractIframeSource(value) || value.trim();

  try {
    const url = new URL(candidate);
    return HTTP_PROTOCOLS.includes(url.protocol) ? url.toString() : undefined;
  } catch {
    return undefined;
  }
};

export const normalizeVideoEmbedUrl = (value: string): string | undefined => {
  const normalizedUrl = normalizeEmbedUrl(value);
  if (!normalizedUrl) {
    return undefined;
  }

  const url = new URL(normalizedUrl);
  const hostname = url.hostname.replace(/^www\./, '');

  if (hostname === 'youtu.be') {
    const videoId = url.pathname.split('/').filter(Boolean)[0];
    return videoId ? `https://www.youtube.com/embed/${videoId}` : undefined;
  }

  if (hostname === 'youtube.com' || hostname === 'm.youtube.com') {
    if (url.pathname === '/watch') {
      const videoId = url.searchParams.get('v');
      return videoId ? `https://www.youtube.com/embed/${videoId}` : undefined;
    }

    if (url.pathname.startsWith('/embed/')) {
      return url.toString();
    }
  }

  if (hostname === 'vimeo.com') {
    const [videoId, hash] = url.pathname.split('/').filter(Boolean);
    if (!videoId) {
      return undefined;
    }

    const hashQuery = hash ? `?h=${encodeURIComponent(hash)}` : '';
    return `https://player.vimeo.com/video/${videoId}${hashQuery}`;
  }

  return url.toString();
};
